"use client"

import Link from "next/link"
import Image from "next/image"
import { cn } from "@/lib/utils"

interface LogoProps {
  className?: string
  showText?: boolean
  size?: "sm" | "md" | "lg"
  href?: string
  disableLink?: boolean // When true, don't render Link even if href is provided
}

export function CrystalityLogo({ className, showText = true, size = "md", href = "/", disableLink = false }: LogoProps) {
  const sizes = {
    sm: { icon: 24, text: "text-lg" },
    md: { icon: 32, text: "text-xl" },
    lg: { icon: 40, text: "text-2xl" },
  }

  const content = (
    <div className={cn("flex items-center gap-2", className)}>
      {/* Logo Icon */}
      <div className="relative flex-shrink-0">
        <Image
          src="/icon.png"
          alt="Crystality Logo"
          width={sizes[size].icon}
          height={sizes[size].icon}
          className="drop-shadow-[0_0_10px_rgba(139,92,246,0.5)]"
          priority
        />
      </div>
      
      {showText && (
        <span className={cn("font-semibold tracking-tight text-foreground", sizes[size].text)}>
          crystality
        </span>
      )}
    </div>
  )

  if (href && !disableLink) {
    return (
      <Link href={href} className="hover:opacity-90 transition-opacity">
        {content}
      </Link>
    )
  }

  return content
}

// Alias for backward compatibility
export const Logo = CrystalityLogo
